import * as React from "react"
import {Box, CircularProgress} from "@mui/material";
import {ModalSeeker} from "@ui-seeker/core";
import {formatPercentage, isEmpty} from "@ui-seeker/utils";

import {isLoadingPriceDiscountModalData, priceDiscountModalData} from "../../../@signals";
import {usePricingDiscountRoleConfig} from "../../../@hooks";
import PricingCandlestickTableModal from "./Table";


export default function PricingCandlestickModal() {
	const { typeKpi } = usePricingDiscountRoleConfig()

	const haveData = !isEmpty(priceDiscountModalData.value)

	return <ModalSeeker
		isOpen={!!haveData || isLoadingPriceDiscountModalData.value}
		controller={() => priceDiscountModalData.value = {}}
		title={isLoadingPriceDiscountModalData.value ? 'Loading data...' : `${typeKpi} ${formatPercentage(priceDiscountModalData.value.discount)}`}
		hideActions
		sx={{ overflow: 'hidden' }}
	>
		{ isLoadingPriceDiscountModalData.value && <Box sx={{ display: 'flex', verticalAlign: 'center', justifyContent: 'center' }}>
			<CircularProgress size={56} />
		</Box> }

		{ !!haveData && <PricingCandlestickTableModal data={priceDiscountModalData.value.list_skus} /> }
	</ModalSeeker>
}